export default "__VITE_ASSET__e28febb8__"